import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link, withRouter } from 'react-router-dom'
import styled, { css } from 'styled-components';

export function UItoggle({
  active,
  size = 12,
  handler = () => void (0),
  label = '',
  radio,
  left = true,
  right
}) {
  const [on, setOn] = useState(active)
  return (
    <>

      <div className="l_info_sum"
        onClick={() => {
          setOn(!on);
          handler();
        }}
      >
        <div className="flex middle gap"
          style={{ position: 'relative' }}

        >
          {/* <div className="x_meta_hover"
            onClick={() => {
              setOn(!on);
              handler();
            }}
          /> */}


          {right && label}

          <CSStoggle0
            className={`${on ? 'active' : ''} ${radio ? 'radio' : ''}`}
            style={{
              fontSize: size
            }}

          >
            <div className={radio ? "ui_toggle ui_toggle--radio" : "ui_toggle"}>
              <div className={`ui_toggle_body ${on ? 'active' : ''}`} />
              <div className={`ui_toggle_thumb ${radio ? 'ui_toggle_thumb--radio' : ''}${on ? 'active' : ''}`} >
                <div className="ico">{on ? 'check' : 'close'}</div>
              </div>
            </div>
          </CSStoggle0>

          {left && <>&nbsp;&nbsp;{label}</>}
        </div>
      </div>
    </>
  )
}

const CSStoggle0 = styled.div`
  &.active:hover .ui_toggle_body {
    background-color: #10b9b2;
  }
  &:hover .ui_toggle_body {
    background-color: #e1f8f7;
  }
  &:hover .ui_toggle_thumb {
    border-color: #e1f8f7;
  }
  &.active:hover .ui_toggle_thumb {
    border-color: #10b9b2;
  }
`